(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sn-header-main"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const header = document.getElementById('sn-header');
    if (!header) return;

    const backdrop = header.querySelector('[data-sn-backdrop]');
    const searchPanel = header.querySelector('[data-sn-search-panel]');
    const searchInput = searchPanel?.querySelector('.sn-search__input');
    const mobilePanel = header.querySelector('[data-sn-mobile-panel]');

    // ===== SEARCH =====
    function openSearch() {
      searchPanel.classList.add('is-open');
      searchPanel.setAttribute('aria-hidden', 'false');
      backdrop.classList.add('is-visible');
      setTimeout(() => searchInput?.focus(), 60);
    }
    function closeSearch() {
      searchPanel?.classList.remove('is-open');
      searchPanel?.setAttribute('aria-hidden', 'true');
      backdrop?.classList.remove('is-visible');
    }
    header.querySelector('[data-sn-search-open]')?.addEventListener('click', openSearch);
    header.querySelector('[data-sn-search-close]')?.addEventListener('click', closeSearch);

    // ===== PREDICTIVE SEARCH (Shopify suggest.json, same-origin) =====
    (function () {
      var resultsEl = searchPanel && searchPanel.querySelector('[data-sn-search-results]');
      var termsEl   = searchPanel && searchPanel.querySelector('[data-sn-search-terms]');
      if (!searchInput || !resultsEl) return;
      var deb, seq = 0;
      function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); }
      function priceHtml(p) {
        var v = p.price;
        if (v == null || v === '') return '';
        if (typeof v === 'number') v = '€' + (v / 100).toFixed(2).replace('.', ',');
        return '<span class="sn-sr__price">' + esc(v) + '</span>';
      }
      function imgHtml(p) {
        var u = (p.featured_image && p.featured_image.url) || p.image || (p.images && p.images[0]) || '';
        if (u && typeof u === 'object') u = u.url || '';
        return u ? '<span class="sn-sr__thumb"><img src="' + esc(u) + '" alt="" loading="lazy"></span>'
                 : '<span class="sn-sr__thumb sn-sr__thumb--empty"></span>';
      }
      function showResults(on) { if (termsEl) termsEl.hidden = on; resultsEl.hidden = !on; }
      function run(q) {
        var my = ++seq;
        var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
                  '&resources[type]=product,article&resources[limit]=8&resources[options][unavailable_products]=last';
        fetch(url, { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            if (my !== seq) return;
            var res = (data && data.resources && data.resources.results) || {};
            var prods = (res.products || []).slice(0, 6);
            var arts  = (res.articles || []).slice(0, 4);
            var html = '';
            if (prods.length) {
              html += '<div class="sn-sr__group"><p class="sn-sr__label">Izdelki</p>';
              prods.forEach(function (p) {
                html += '<a class="sn-sr__item sn-sr__item--prod" href="' + esc(p.url) + '">' + imgHtml(p) +
                        '<span class="sn-sr__info"><span class="sn-sr__title">' + esc(p.title) + '</span>' + priceHtml(p) + '</span></a>';
              });
              html += '</div>';
            }
            if (arts.length) {
              html += '<div class="sn-sr__group"><p class="sn-sr__label">Rastline in članki</p>';
              arts.forEach(function (a) {
                html += '<a class="sn-sr__item sn-sr__item--art" href="' + esc(a.url) + '"><span class="sn-sr__title">' + esc(a.title) + '</span></a>';
              });
              html += '</div>';
            }
            if (!html) html = '<p class="sn-sr__empty">Ni zadetkov za “' + esc(q) + '”.</p>';
            html += '<a class="sn-sr__all" href="/search?q=' + encodeURIComponent(q) + '&type=product,article">Prikaži vse zadetke →</a>';
            resultsEl.innerHTML = html;
          })
          .catch(function () {
            if (my !== seq) return;
            resultsEl.innerHTML = '<a class="sn-sr__all" href="/search?q=' + encodeURIComponent(q) + '&type=product,article">Prikaži vse zadetke →</a>';
          });
      }
      searchInput.addEventListener('input', function () {
        var q = (searchInput.value || '').trim();
        clearTimeout(deb);
        if (q.length < 2) { showResults(false); resultsEl.innerHTML = ''; return; }
        showResults(true);
        if (!resultsEl.innerHTML) resultsEl.innerHTML = '<p class="sn-sr__loading">Iščem…</p>';
        deb = setTimeout(function () { run(q); }, 160);
      });
    })();

    // ===== MOBILE =====
    function openMobile() {
      mobilePanel.classList.add('is-open');
      mobilePanel.setAttribute('aria-hidden', 'false');
      mobilePanel.inert = false;
      backdrop.classList.add('is-visible');
      document.body.style.overflow = 'hidden';
    }
    function closeMobile() {
      mobilePanel?.classList.remove('is-open');
      mobilePanel?.setAttribute('aria-hidden', 'true');
      if (mobilePanel) mobilePanel.inert = true;
      backdrop?.classList.remove('is-visible');
      document.body.style.overflow = '';
    }
    header.querySelector('[data-sn-mobile-open]')?.addEventListener('click', openMobile);
    header.querySelector('[data-sn-mobile-close]')?.addEventListener('click', closeMobile);

    // Backdrop / Esc close
    backdrop.addEventListener('click', () => { closeSearch(); closeMobile(); });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') { closeSearch(); closeMobile(); }
    });

    // ===== STICKY shadow + auto-hide (reveal on scroll up) =====
    const headerGroup = document.getElementById('header-group') || header;
    let lastScroll = 0;
    let ticking = false;
    const HIDE_AFTER = 160; // px scrolled before the header may auto-hide
    window.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        const y = window.scrollY;
        // Shadow once scrolled
        if (y > 4) header.classList.add('is-scrolled');
        else header.classList.remove('is-scrolled');
        // Auto-hide on scroll down, reveal on scroll up — toggled on the sticky #header-group.
        // Never hide while the search overlay or mobile drawer is open (backdrop visible).
        if (backdrop.classList.contains('is-visible') || y <= HIDE_AFTER) {
          headerGroup.classList.remove('sn-header--hidden');
        } else if (y > lastScroll + 4) {
          headerGroup.classList.add('sn-header--hidden');
        } else if (y < lastScroll - 4) {
          headerGroup.classList.remove('sn-header--hidden');
        }
        lastScroll = y;
        ticking = false;
      });
    }, { passive: true });
  })();

  } catch(e) { console.error(e); }
})();
})();
